<template>
  <form class="fieldset profile-right"
        @submit.prevent="chagePass"
        @click="formEdit">
    <h3 class="legend">{{$t('profile.passTitle')}}</h3>
    <label class="input-cont_underline" :class="{'disabled': !edited, 'error': $v.pass.$error}">
      <label class="label">{{$t('forms.oldPasswordLabel')}}</label>
      <input type="password"
             v-model="pass"
             @blur="$v.pass.$touch()"
             @focus="$v.pass.$reset();hideWrongPass()"
             :disabled="!edited">
      <errors v-show="$v.pass.$dirty && !$v.pass.required"></errors>
      <errors :type="'wrongPass'" v-show="wrongPass"></errors>
    </label>
    <label class="input-cont_underline" :class="{'disabled': !edited,'error': $v.newPass1.$error}">
      <label class="label">{{$t('forms.newPasswordLabel')}}</label>
      <input type="password"
             v-model="newPass1"
             @blur="$v.newPass1.$touch()"
             @focus="$v.newPass1.$reset()"
             :disabled="!edited">
      <errors v-show="$v.newPass1.$error"></errors>
    </label>
    <label class="input-cont_underline" :class="{'disabled': !edited, 'error': $v.newPass2.$error}">
      <label class="label">{{$t('forms.repeatPasswordPl')}}</label>
      <input type="password"
             v-model="newPass2"
             @blur="$v.newPass2.$touch()"
             @focus="$v.newPass2.$reset()"
             :disabled="!edited">
      <errors v-show="$v.newPass2.$dirty && !$v.newPass2.required"></errors>
      <errors type="passDouble" v-show="$v.newPass2.$dirty && !$v.newPass2.sameAs"></errors>
    </label>
    <button type="submit"
            :disabled="!edited || $v.$anyError || loading || disableBtn"
            :class="{'loading': loading}"
            class="btn btn-transparent_dark">{{$t('btns.changePass')}}</button>
    <transition name="fade">
      <p v-if="successPass" class="success-message font-semi-bold">{{$t('profile.successPass')}}</p>
    </transition>
  </form>
</template>

<script>
  import {sameAs,required} from 'vuelidate/lib/validators'
  import errors from '../../Forms/errors'
  import {createNamespacedHelpers} from 'vuex'

  const {mapState} = createNamespacedHelpers('profile');
  const {mapActions} = createNamespacedHelpers('profile');
  const {mapMutations} = createNamespacedHelpers('profile')

  export default {
    name: 'profile-right',
    props: {
      edited: {
        type: Boolean,
        default: false
      }
    },
    components: {
      errors
    },
    data() {
      return {
        pass: '',
        newPass1: '',
        newPass2: '',
        loading: false,
        wrongPass: false,
        successPass: false
      }
    },
    validations: {
      pass: {
        required,
      },
      newPass1: {
        required
      },
      newPass2: {
        required,
        sameAs: sameAs('newPass1')
      }
    },
    computed: {
      ...mapState([
        'oldPass'
      ]),
      disableBtn() {
        if (!this.pass || !this.newPass1 || !this.newPass2) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapActions([
        'updateUserPass'
      ]),
      ...mapMutations([
        'SET_OLD_PASS'
      ]),
      chagePass() {
        const token = this.$store.state.auth.token
        let data = {
          current_password: this.pass,
          password: this.newPass1,
          //access_token: token
        };
        this.loading = true;

        this.updateUserPass(data)
          .then(() => {
            this.loading = false;
            this.successPass = true;
            setTimeout(() => this.successPass = false, 3000);
            this.newPass1 = '';
            this.newPass2 = '';
            this.pass = '';
            this.SET_OLD_PASS = data.password;
            this.$v.pass.$reset();
            this.$v.newPass1.$reset();
            this.$v.newPass2.$reset();
          }).catch((e) => {
            this.loading = false;
            this.newPass1 = '';
            this.newPass2 = '';
            this.pass = '';
            this.$v.pass.$reset();
            this.$v.newPass1.$reset();
            this.$v.newPass2.$reset();
            let response = e.response.data.message;
            if (response.includes('password')) {
              this.wrongPass = true;
            };
            if (response.includes('access')) {
              this.$store.dispatch('auth/logout')
            }

        })
      },
      formEdit() {
        this.$emit('formEdit')
      },
      hideWrongPass() {
        this.wrongPass = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .profile-right {
    width: 50%;
    padding-left: 40px;
  }

  label {
    margin-bottom: 35px;
  }

  .disabled {
    opacity: 0.5;
  }

  input:disabled {
    border: 1px solid $lightGrey!important;
  }

  .loading {
    background: #505D6F!important;

    &:hover {
      background: #505D6F;
    }
  }

  .success-message {
    text-align: center;
    margin-top: 10px;
    color: $lightBlue;
  }
</style>
